/**
 * @module ol/asserts
 */
import AssertionError from './AssertionError.js';
/**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {number} errorCode Error code.
 */
export function assert(assertion, errorCode) {
    if (!assertion) {
        throw new AssertionError(errorCode);
    }
}
//# sourceMappingURL=asserts.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/asserts.js
// module id = 28
// module chunks = 8